import { db } from "./firebase-config";
import { doc, serverTimestamp, setDoc } from "firebase/firestore";

// Store only non-sensitive user profile data alongside Firebase Auth.
export const addUserProfileToFirestore = async (userId, profile) => {
  if (!userId) {
    throw new Error("User ID is required");
  }

  const name = (profile?.name || "").trim();
  const email = (profile?.email || "").trim().toLowerCase();

  if (!name || !email) {
    throw new Error("Name and email are required");
  }

  await setDoc(
    doc(db, "users", userId),
    {
      name,
      email,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
    },
    { merge: true }
  );
};
